import AppService, { Utilities, AlertService } from 's2s-app-service';
import themes from '../themes/theme-styles.js';
import { addLocaleData } from 'react-intl';
import Messages from '../js/messages';
import LoggingService from 's2s-logging-service';
import Utils from '../js/utilities';
import { doGetUserContacts, doUpdateCallServiceSettings } from './index';
import objectMerge from 'object-merge';

const doSettingsClick = (history) => {
  return (dispatch, getState) =>{
    history.push('/appmain/settingsnav');
   };
};

const doSettingsButtonClick = (history, buttonclicked) => {
  return (dispatch, getState) =>{
    dispatch ({
      "type": 'CHANGE_SETTINGS_MENU',
      "payload": {'currentSettingsCategory': buttonclicked}
    })

    history.push('/appmain/settingscategory');
   };
};
const doAlertListButtonClick = (buttonclicked) => {
  return (dispatch, getState) =>{
    dispatch ({
      "type": 'CHANGE_SETTINGS_MENU',
      "payload": {'currentSettingsCategory': buttonclicked}
    });
   };
};

const doSettingsListBackClick = (history) => {
  return (dispatch, getState) =>{

    // NOTE: Wrapping this dispatch in a setTimeout so that when motioning back to SettingsNav
    // we won't see the 'collapsed' version of SettingsCategory (due to currentSettingsCategory being undefined) - KCN

    history.goBack(); // goBack takes place immediately

    setTimeout(()=>{
      dispatch ({
        "type": 'CHANGE_SETTINGS_MENU',
        "payload": {'currentSettingsCategory': undefined}
      });
    }, 500); // AnimationSlideLR component takes 400MS to slide Animations in/out.

   };
};

const doAlertListBackClick = (history) => {
  return (dispatch, getState) =>{
    dispatch ({
      "type": 'CHANGE_SETTINGS_MENU',
      "payload": {'currentSettingsCategory': "Troubleshooting"}
    });
   };
};

const timeoutForContactImportSyncTime = (syncType, properties, dispatch) => {
  //This time out is here because we are not able to use pubsub and this provides a false time until it can be refreshed with a new login
  setTimeout(()=>{
    let newProperties = objectMerge({}, properties);
    newProperties[syncType] = Date.now().toString();
    dispatch ({
      "type": 'UPDATE_IDENTITY_PROPERTIES',
      "payload": newProperties,
    });
    dispatch(doGetUserContacts());
  }, 5000
  );
  setTimeout(()=>{
    let newProperties = objectMerge({}, properties);
    newProperties[syncType] = Date.now().toString();
    dispatch ({
      "type": 'UPDATE_IDENTITY_PROPERTIES',
      "payload": newProperties,
    });
    dispatch(doGetUserContacts());
  }, 30000
  );
};

const doUpdateSettings = (key, value, csvFile) => {
  LoggingService.getInstance().debug('AC ---- doUpdateSettings', key, value);
  return (dispatch, getState) =>{
    const store = getState();
    // 1. Update the store with the new value....
    dispatch ({
      "type": 'SETTINGS_UPDATE',
      "payload": {key, value},
      "meta": {
        "analytics":{
          'category':'settings',
          'action': 'updated',
          'name': key,
          'value': value
        }
      }
    });

    // theme and language changes do NOT require restart....
    switch (key ) {
      case 'theme':
        setTimeout(()=>{dispatch(doSetUITheme()); }, 0); //jes if not setTimeout will cause setState on unmounted component
        break;
      case 'language':
        setTimeout(()=>{dispatch(doSetLanguage()); }, 0);//jes if not setTimeout will cause setState on unmounted component
        break;
      case 'alwaysontop':
        LoggingService.getInstance().debug('always on top ', key ,value );
        if (typeof setAlwaysOnTop == 'function'){
          setAlwaysOnTop(value);
        } else if (typeof(window['setAlwaysOnTop']) == 'function') {
          window.setAlwaysOnTop(value);
        } else {
          LoggingService.getInstance().info('^^^^^^^^^^^ NO setAlwaysOnTop ???');
        }
        break;
      case 'advancedLogging':
        //console.log('>>>>>>>>> ', key ,value )
        AppService.getInstance().advancedLogging = value;
        if (typeof setLogLevel == 'function'){
          setLogLevel(value ? 'debug' : 'info');
        } else if (typeof(window['setLogLevel']) == 'function') {
          window.setLogLevel(value ? 'debug' : 'info');
        } else {
          //console.log('^^^^^^^^^^^ NO incomingCall ???', this, window);
        }
        break;
      case 'replayIntroSlides':
        // TODO call action creator to route to intro slides...
        //console.log('Replay Intro slides');
        break;
      case 'importContacts':
      {
        //console.log('importContacts AC', key, value);
        // build url
        let contactsBaseUrl = 'https://contacts.star2star.com/';
        switch(Utils.getEnvironment()){
          case 'dev':
            contactsBaseUrl = 'http://localhost:8000';
            break;
          case 'test':
            contactsBaseUrl = 'https://contacts.star2star.net';
            break;
          default:
            contactsBaseUrl = 'https://contacts.star2star.com';
            break;
        }

        let newProperties = {
          lastgooglesync: store && store.auth && store.auth.identitydata && store.auth.identitydata.properties && store.auth.identitydata.properties.lastgooglesync ? store.auth.identitydata.properties.lastgooglesync : undefined,
          lastoutlooksync: store && store.auth && store.auth.identitydata && store.auth.identitydata.properties && store.auth.identitydata.properties.lastoutlooksync ? store.auth.identitydata.properties.lastoutlooksync : undefined,
          lastcsvsync: store && store.auth && store.auth.identitydata && store.auth.identitydata.properties && store.auth.identitydata.properties.lastcsvsync ? store.auth.identitydata.properties.lastcsvsync : undefined
        };

        let contactUrlSuffix = '/';
        switch(value.toLowerCase()){
          case 'google':
            contactUrlSuffix = '/login/google';
            //console.log('-----', `${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`)
            if (typeof openUrl == 'function'){
              openUrl(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            } else if (typeof(window['openUrl']) == 'function') {
              window.openUrl(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}` );
            } else {
              window.open(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            }
            timeoutForContactImportSyncTime('lastgooglesync', newProperties, dispatch);
            break;
          case 'outlook':
            contactUrlSuffix = '/login/outlook';
            //console.log('-----', `${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            if (typeof openUrl == 'function'){
              openUrl(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            } else if (typeof(window['openUrl']) == 'function') {
              window.openUrl(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}` );
            } else {
              window.open(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            }
            timeoutForContactImportSyncTime('lastoutlooksync', newProperties, dispatch);
            break;
          case 'csv': {
              //console.log('handle csv stuff here ', csvFile);//TODO upload file

            contactUrlSuffix = '/upload';
            //console.log('-----', `${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`);
            if (!csvFile || !csvFile.name || csvFile.name.indexOf('.csv') < 0){
              AlertService.getInstance().createErrorAlert({
                alertHeadingText: Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR-TITLE', 'CSV Import Error'),
                alertBodyText: Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR', 'file name must be .csv; your file name was: ') +csvFile.name,
                isPersistent: false
              });
              return;
            }
            var myForm = new FormData();
            myForm.append('file', csvFile);

            const fetchOptions = {
              "method": "POST",
              "body": myForm
            };
            //console.log('STORE', store)

            fetch(`${contactsBaseUrl}${contactUrlSuffix}?user_uuid=${store.auth.identitydata.uuid}`, fetchOptions).then((response)=>{
              response.json().then((data)=>{
                if (data.hasOwnProperty('status') && data.status !== 200) {
                  // show alert with error status
                  // calling AlertService
                  AlertService.getInstance().createErrorAlert({
                    alertHeadingText:  Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR-TITLE', 'CSV Import Error'),
                    alertBodyText: 'status: ' + data.status + '\n ' + 'message: ' + data.message,
                    isPersistent: false
                  });
                } else {
                  timeoutForContactImportSyncTime('lastcsvsync', newProperties, dispatch);
                }
                //document.getElementById('results').innerText = `${JSON.stringify(data)}`;
              }).catch((jsonError)=>{
                console.log('jjjjj', jsonError);
              });
            }).catch((e)=>{

            });
            break;
          }
        }
        break;
      }
      default:
        if (store.app.hasOwnProperty('status') && store.app.status.hasOwnProperty('status') && store.app.status.status === 'connected' ) {
          LoggingService.getInstance().debug('------> ', key ,value )
          if(store.callInfo.inprogressCalls && Object.keys(store.callInfo.inprogressCalls).length <= 0){
            dispatch(doUpdateCallServiceSettings());
          } else {
            AlertService.getInstance().createInfoAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_INFO_SETTINGS_UPDATE', 'Settings Update') , alertBodyText: Utilities.getInstance().getIntlMessage('ALERT_SETTINGS_WILL_APPLY', 'Active calls; settings will apply when idle.'), autoCloseTimeout: 2});
            dispatch({
              "type": 'SETTINGS_UPDATE_DEFERMENT',
              "payload": {key, value}
            });
          }
        } else {
          LoggingService.getInstance().debug('currently not connected ignoring setting call service ', key ,value )
        }
    } // end switch
  };
};

const doSetUITheme = () => {
  LoggingService.getInstance().debug('AC ---- doSetUITheme');
  return (dispatch, getState) =>{
    const store = getState();

    let appliedTheme = {};
    let appliedThemeName = 'default';
    if (store.settings.selectedTheme ){
      LoggingService.getInstance().debug('selectedTheme', store.settings.selectedTheme);
      appliedThemeName = store.settings.selectedTheme;
      appliedTheme = ( themes[store.settings.selectedTheme] ? themes[store.settings.selectedTheme] : {} );
      LoggingService.getInstance().debug('appliedTheme: ', appliedTheme );
    }

    dispatch({
              type: 'APP_SET_UI_THEME',
              payload:  {
                          appliedTheme: appliedTheme,
                          appliedThemeName: appliedThemeName
                        }
            });
  };
};


const doSetLanguage = () => {
  LoggingService.getInstance().debug('AC ---- doSetLanguage');
  return (dispatch, getState) =>{
    const store = getState();

    let locale, dialect, messages, localeData;
    dialect = store.settings && store.settings.selectedLanguage ? store.settings.selectedLanguage.id : 'en';
    locale = dialect;
    messages = (new Messages(dialect)).getAllMessages();
    // inject onto utilities
    Utilities.getInstance().setIntlMessages(messages);
    // needed for INTL
    localeData = require('react-intl/locale-data/'+dialect);
    LoggingService.getInstance().debug('dialect, messages', dialect, messages);
    addLocaleData(localeData);

    dispatch({
              type: 'APP_SET_LANGUAGE',
              payload:  {
                          locale: locale,
                          messages: messages
                        }
            });
  };
};

const doHandleIdentityPropChange = (eventData) => {
  return ((dispatch)=>{
    dispatch({
      'type': 'UPDATE_IDENTITY_PROPERTIES',
      'payload': {...eventData.metadata.properties}
    });

    if (eventData.metadata.properties.hasOwnProperty('last_csv_sync') ||
        eventData.metadata.properties.hasOwnProperty('last_outlook_sync') ||
        eventData.metadata.properties.hasOwnProperty('last_google_sync')) {

          // Retrieve the updated contactlist
          dispatch(doGetUserContacts());
        }

  });

};

export {doSettingsClick, doUpdateSettings, doSettingsButtonClick, doSettingsListBackClick, doSetUITheme, doSetLanguage, doHandleIdentityPropChange, doAlertListButtonClick, doAlertListBackClick};



// WEBPACK FOOTER //
// ./src/action-creators/settings.js